import React from "react";
import {
  ClavaContextType,
  ClavaRootContextType,
  DropDownContextType,
} from "./types";
import { User } from "../client/api";
import { browserLang } from "./utils";

export const ClavaRootContext = React.createContext<ClavaRootContextType>({
  theme: "dark",
  fbToken: "",
  initialized: false,
  setTheme: undefined,
});
export const ClavaContext = React.createContext<ClavaContextType>({
  l: browserLang(),
  aoi: -1,
  user: {} as User,
  pro: false,
});

export const DropDownContext = React.createContext<DropDownContextType>({
  setOpen: () => {
    //
  },
  setClose: () => {
    //
  },
});
